import { AlertTriangle } from 'lucide-react';
import { useRef } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/components/shadcn/alert-dialog';

interface Props {
  isOpen: boolean;
  onClose?: () => void;
  onUnmount?: () => void;
  title?: string;
  message: string;
}

export function ErrorDialog({ isOpen, onClose, onUnmount, title = 'Error', message }: Props) {
  const contentRef = useRef<HTMLDivElement>(null);

  const handleClose = () => {
    onClose?.();
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      handleClose();
    }
  };

  const handleAnimationEnd = (event: React.AnimationEvent) => {
    if (!isOpen && event.animationName === 'exit') {
      onUnmount?.();
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent
        ref={contentRef}
        className="w-full max-w-lg"
        onAnimationEnd={handleAnimationEnd}
      >
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <AlertTriangle className="h-6 w-6 text-red-500" />
            <AlertDialogTitle className="text-lg font-semibold text-red-600">
              {title}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-sm text-zinc-600">
            {message}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogAction onClick={handleClose}>OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
